import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'

export default {
  name: 'ServiceForm',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.pageTitle + ' | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String
  },
  data () {
    return {
      loading: true
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Service')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.resetForm()
  },
  computed: {
    ...mapState({
      categoryName: state => state.service.categoryName
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      getPermission: 'permission/get'
    }),

    pageTitle () {
      return this.categoryName + '新規作成'
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      loadModel: 'serviceForm/loadModel',
      resetForm: 'serviceForm/reset'
    }),
    
    init () {
      this.loading = true

      //
      let tenantParams = { filters: {} }

      // データ読出し
      this.loadModel({
        targetId: this.serviceId,
        tenantParams: tenantParams,
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    }
  }
}
